module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "1200px"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Invoice History #" + _vm._s(_vm.invoice_id))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.invoiceHistory) ? _c('div', {
    staticClass: "content"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.invoiceHistory), function(history) {
    return _c('tr', [(history.service) ? [_c('td', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.url(history.service.id)
        }
      }
    }, [_vm._v(_vm._s(history.service.api_booking_id + '/' + history.service.api_service_id))])])] : [_c('td')], _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(history.history)
      }
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.parseDate(history.created_at)))])], 2)
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.close(false)
      }
    }
  }, [_vm._v("Cancel")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Booking-Service")]), _vm._v(" "), _c('th', [_vm._v("History")]), _vm._v(" "), _c('th', [_vm._v("Date")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25a2226a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/finances/V2/invoice/InvoiceHistory.vue
// module id = 1087
// module chunks = 39